import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogActions, Table, TableBody, TableRow, TableCell,
  TablePagination, Paper } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import AppBarModal from '../../../general/AppBarModal';
import ListarDatos from '../../../general/ListarDatos';
import TareasTerminadas from '../../../general/TareasTerminadas';
import { BtnDetalle, BtnEditar, BtnForm } from '../../../general/BotonesAccion';
import emma_w from '../../../../global/imagenes/emma_w.png';
import emma_s1 from '../../../../global/imagenes/emma_s1.png';
import { consulta, obtenerValores } from '../../../../global/js/funciones';
import { PAISES, ESTADOS_CONVENIOS } from '../helper';
import { COLUMNAS } from './excelConvenios';
import ConvenioRegistradoEditar from './ConvenioRegistradoEditar';

// Los convenios en Con_regis y los cargados en masa, que estan en Con_reg_mas.
// El asistente de 5 pasos no sirve para corregirlos: tienen paso_actual en null.

const ROJO = '#900807';

// El spacer de TablePagination lo empuja contra los botones flotantes de la derecha.
const PaginacionCentrada = withStyles({
  spacer: { flex: 'none' },
  toolbar: { justifyContent: 'center', flexWrap: 'wrap' },
})(TablePagination);

class ConveniosRegistrados extends Component {
  constructor(props) {
    super(props);
    this.state = {
      convenios: [],
      paises: [],
      estados: [],
      cargando: true,
      guardando: false,
      busqueda: '',
      pagina: 0,
      porPagina: 10,
      modalDetalle: false,
      modalEditar: false,
      actual: null,      // el convenio abierto, tal como lo devuelve el backend
    };
  }

  async componentDidMount() {
    let [paises, estados] = await Promise.all([obtenerValores(PAISES), obtenerValores(ESTADOS_CONVENIOS)]);
    this.setState({
      paises: (paises || []).map(({ nombre }) => nombre).filter(Boolean).sort(),
      estados: (estados || []).map(({ nombre }) => nombre).filter(Boolean),
    });
    await this.obtenerConvenios();
  }

  obtenerConvenios = () => {
    this.setState({ cargando: true });
    return new Promise((resolve) => {
      consulta('api/v1.0/internacionalizacion/convenios/registrados', null, null, (error, estado, resp) => {
        let convenios = (!error && estado === 200 && resp && resp.convenios) ? resp.convenios : [];
        if (error || estado !== 200) {
          this.props.actualizarMensaje({ titulo: 'No fue posible cargar los convenios.', tipo: 'error', mostrar: true, tiempo: 6000 });
        }
        this.setState({ convenios, cargando: false });
        resolve();
      });
    });
  }

  // ListarDatos solo recibe una pagina: la busqueda va por fuera o solo veria esa.
  filtrar = (convenios, busqueda) => {
    let texto = String(busqueda || '').trim().toLowerCase();
    if (!texto) return convenios;
    return convenios.filter((c) => ['CODIGO', 'INSTITUCION', 'PAIS', 'ESTADO']
      .some((clave) => String(c[clave] || '').toLowerCase().indexOf(texto) >= 0));
  }

  abrirDetalle = (convenio) => this.setState({ actual: convenio, modalDetalle: true })

  abrirEditar = (convenio) => this.setState({ actual: convenio, modalEditar: true })

  acciones = (convenio) => {
    let { administrador } = this.props;
    return (
      <>
        <BtnDetalle callback={() => this.abrirDetalle(convenio)} color='#01579b' texto='Abrir' />
        {administrador && <BtnEditar callback={() => this.abrirEditar(convenio)} color='#01579b' texto='Editar' />}
      </>
    );
  }

  pintarDetalle() {
    let { modalDetalle, actual } = this.state;
    return (
      <Dialog open={modalDetalle} onClose={() => this.setState({ modalDetalle: false })} fullWidth maxWidth='sm'>
        <AppBarModal titulo='¡ Detalle del convenio !' mostrarModal={() => this.setState({ modalDetalle: false })} titulo_accion='' accion='' />
        <DialogContent className='scroll'>
          {
            actual &&
            <Table size='small'>
              <TableBody>
                {COLUMNAS.map(({ clave, etiqueta }) => (
                  <TableRow key={clave}>
                    <TableCell style={{ width: '45%', color: 'rgba(0,0,0,0.54)' }}>{etiqueta}</TableCell>
                    <TableCell>{actual[clave] === '' || actual[clave] === null ? '—' : actual[clave]}</TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell style={{ color: 'rgba(0,0,0,0.54)' }}>Estado de la solicitud</TableCell>
                  <TableCell>{actual.estado_solicitud}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          }
        </DialogContent>
        <DialogActions>
          <BtnForm texto='CERRAR' callback={() => this.setState({ modalDetalle: false })} />
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    let { convenios, cargando, busqueda, pagina, porPagina, modalEditar, actual } = this.state;
    if (cargando) return <TareasTerminadas mensaje='Cargando convenios..' marginTop='30%' imagen={emma_w} widthImg='7%' />;
    if (convenios.length === 0) {
      return <TareasTerminadas mensaje='Aún no hay convenios registrados.' marginTop='30%' imagen={emma_s1} widthImg='7%' />;
    }

    let filtrados = this.filtrar(convenios, busqueda);
    let ultima = Math.max(0, Math.ceil(filtrados.length / porPagina) - 1);
    let pag = Math.min(pagina, ultima);
    let visibles = filtrados.slice(pag * porPagina, pag * porPagina + porPagina);

    return (
      <div style={{ padding: '2% 2% 0 2%' }}>
        <ListarDatos
          datos={visibles}
          titulo={busqueda
            ? `Convenios registrados: ${filtrados.length} de ${convenios.length}`
            : `Convenios registrados: ${convenios.length}`}
          id='tbl_convenios_registrados'
          opciones={true}
          buscar={true}
          actBuscar={(texto) => this.setState({ busqueda: texto, pagina: 0 })}
          datoBuscarAlt={busqueda}
          refrescar={true}
          actRefrescar={() => this.obtenerConvenios()}
          sub_titulo='Convenios'
          acciones={(row) => this.acciones(row)}
          avatar={({ INSTITUCION }) => (INSTITUCION ? INSTITUCION.charAt(0).toUpperCase() : 'C')}
          fila_principal={({ INSTITUCION }) => (INSTITUCION ? INSTITUCION.toUpperCase() : 'SIN NOMBRE')}
          filas={[
            { 'nombre': 'Código: ', 'id': 'CODIGO', 'mostrar': ({ CODIGO }) => CODIGO || 'No registra' },
            { 'nombre': 'País: ', 'id': 'PAIS', 'mostrar': ({ PAIS }) => PAIS || 'No registra' },
            { 'nombre': 'Vigencia: ', 'id': 'VIGENCIA', 'mostrar': ({ VIGENCIA, FECHA_INICIO, FECHA_FINALIZACION }) => `${VIGENCIA !== '' ? VIGENCIA + ' años' : 'No registra'}${FECHA_INICIO ? ` (${FECHA_INICIO} a ${FECHA_FINALIZACION || '—'})` : ''}` },
            { 'nombre': 'Estado del convenio: ', 'id': 'ESTADO', 'mostrar': ({ ESTADO }) => ESTADO || 'No registra' },
          ]}
        />
        {
          filtrados.length === 0
            ? <Paper elevation={0} style={{ padding: '24px', textAlign: 'center', color: 'rgba(0,0,0,0.54)' }}>
              {`No hay convenios que coincidan con "${busqueda}".`}
            </Paper>
            : <PaginacionCentrada
              component='div'
              count={filtrados.length}
              page={pag}
              rowsPerPage={porPagina}
              rowsPerPageOptions={[10, 25, 50, 100]}
              labelRowsPerPage='Convenios por página:'
              labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
              backIconButtonProps={{ 'aria-label': 'Página anterior' }}
              nextIconButtonProps={{ 'aria-label': 'Página siguiente' }}
              onPageChange={(e, nueva) => this.setState({ pagina: nueva })}
              onRowsPerPageChange={({ target }) => this.setState({ porPagina: parseInt(target.value, 10), pagina: 0 })}
            />
        }
        {this.pintarDetalle()}
        {
          modalEditar &&
          <ConvenioRegistradoEditar
            abierto={modalEditar}
            convenio={actual}
            paises={this.state.paises}
            estados={this.state.estados}
            codigosExistentes={convenios.filter(({ id }) => !actual || id !== actual.id).map(({ CODIGO }) => CODIGO)}
            actualizarMensaje={this.props.actualizarMensaje}
            cerrar={() => this.setState({ modalEditar: false, actual: null })}
            onGuardado={async () => {
              this.setState({ modalEditar: false, actual: null });
              await this.obtenerConvenios();
            }}
          />
        }
      </div>
    );
  }
}

ConveniosRegistrados.propTypes = {
  actualizarMensaje: PropTypes.func.isRequired,
  administrador: PropTypes.bool,
};

export default ConveniosRegistrados;
